/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/settingsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Settings. */
export class Settings {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Settings.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Settings API to update current users's onboarding status.
   * @summary Updates current user's onboarding status.
   * @param [options] The optional parameters
   * @returns Promise<Models.SettingsUpdateUserOnboardingStatusResponse>
   */
  updateUserOnboardingStatus(options?: Models.SettingsUpdateUserOnboardingStatusOptionalParams): Promise<Models.SettingsUpdateUserOnboardingStatusResponse>;
  /**
   * @param callback The callback
   */
  updateUserOnboardingStatus(callback: coreHttp.ServiceCallback<Models.OnboardingStatus>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  updateUserOnboardingStatus(options: Models.SettingsUpdateUserOnboardingStatusOptionalParams, callback: coreHttp.ServiceCallback<Models.OnboardingStatus>): void;
  updateUserOnboardingStatus(options?: Models.SettingsUpdateUserOnboardingStatusOptionalParams | coreHttp.ServiceCallback<Models.OnboardingStatus>, callback?: coreHttp.ServiceCallback<Models.OnboardingStatus>): Promise<Models.SettingsUpdateUserOnboardingStatusResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      updateUserOnboardingStatusOperationSpec,
      callback) as Promise<Models.SettingsUpdateUserOnboardingStatusResponse>;
  }

  /**
   * Calls Settings API to update current users's list of the dismissed devices.
   * @summary Dismiss current user's device suggestion.
   * @param [options] The optional parameters
   * @returns Promise<Models.SettingsDismissDeviceSuggestionResponse>
   */
  dismissDeviceSuggestion(options?: Models.SettingsDismissDeviceSuggestionOptionalParams): Promise<Models.SettingsDismissDeviceSuggestionResponse>;
  /**
   * @param callback The callback
   */
  dismissDeviceSuggestion(callback: coreHttp.ServiceCallback<string>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  dismissDeviceSuggestion(options: Models.SettingsDismissDeviceSuggestionOptionalParams, callback: coreHttp.ServiceCallback<string>): void;
  dismissDeviceSuggestion(options?: Models.SettingsDismissDeviceSuggestionOptionalParams | coreHttp.ServiceCallback<string>, callback?: coreHttp.ServiceCallback<string>): Promise<Models.SettingsDismissDeviceSuggestionResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      dismissDeviceSuggestionOperationSpec,
      callback) as Promise<Models.SettingsDismissDeviceSuggestionResponse>;
  }

  /**
   * Calls Flight settings to get open app links.
   * @summary Gets open app links.
   * @param [options] The optional parameters
   * @returns Promise<Models.SettingsGetAllOpenAppLinksResponse>
   */
  getAllOpenAppLinks(options?: coreHttp.RequestOptionsBase): Promise<Models.SettingsGetAllOpenAppLinksResponse>;
  /**
   * @param callback The callback
   */
  getAllOpenAppLinks(callback: coreHttp.ServiceCallback<Models.AppLinksSettings>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAllOpenAppLinks(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.AppLinksSettings>): void;
  getAllOpenAppLinks(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.AppLinksSettings>, callback?: coreHttp.ServiceCallback<Models.AppLinksSettings>): Promise<Models.SettingsGetAllOpenAppLinksResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAllOpenAppLinksOperationSpec,
      callback) as Promise<Models.SettingsGetAllOpenAppLinksResponse>;
  }

  /**
   * Calls Settings API to delete users's setting.
   * @summary Deletes user's setting by provided setting type.
   * @param settingType Possible values include: 'OnboardingStatus', 'DismissedDevices',
   * 'AvatarColors', 'DeviceIdsWithFixedAlerts'
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  deleteSetting(settingType: Models.SettingType, options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param settingType Possible values include: 'OnboardingStatus', 'DismissedDevices',
   * 'AvatarColors', 'DeviceIdsWithFixedAlerts'
   * @param callback The callback
   */
  deleteSetting(settingType: Models.SettingType, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param settingType Possible values include: 'OnboardingStatus', 'DismissedDevices',
   * 'AvatarColors', 'DeviceIdsWithFixedAlerts'
   * @param options The optional parameters
   * @param callback The callback
   */
  deleteSetting(settingType: Models.SettingType, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  deleteSetting(settingType: Models.SettingType, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        settingType,
        options
      },
      deleteSettingOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const updateUserOnboardingStatusOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Settings/onboardingStatus",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "Enum",
        allowedValues: [
          "Unknown",
          "InProgress",
          "Postponed",
          "Completed"
        ]
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "InProgress",
            "Postponed",
            "Completed"
          ]
        }
      }
    },
    201: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Enum",
          allowedValues: [
            "Unknown",
            "InProgress",
            "Postponed",
            "Completed"
          ]
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const dismissDeviceSuggestionOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/me/Settings/dismissDeviceSuggestion",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: {
      serializedName: "body",
      type: {
        name: "String"
      }
    }
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "String"
        }
      }
    },
    201: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "String"
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getAllOpenAppLinksOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/Settings/openAppLinks",
  responses: {
    200: {
      bodyMapper: Mappers.AppLinksSettings
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const deleteSettingOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "DELETE",
  path: "api/v1/me/Settings/{settingType}",
  urlParameters: [
    Parameters.settingType
  ],
  responses: {
    204: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
